import enCompanyScore from './en';
import ruCompanyScore from './ru';

export default {
  en: {
    ...enCompanyScore,
  },
  ru: {
    ...ruCompanyScore,
  },
};
